module.exports = __webpack_public_path__ + "static/media/57.340d755e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/57.jpg
// module id = 425
// module chunks = 0